import { GetStaticPageContentRequest, GetStaticPageContentResponse } from "@amzn/pv-starlight-presentation-service-lambda-typescript-client";
import { RequestContext } from "../../../@types/dvwebnode";
import { AccessToken, APIClient } from "./APIClient";
import { Logger } from "../logger/logger";
import { constructRequest, OperationType } from "./request";
import { Services } from "./services";
import { AuthMode } from "./WPSClient";

export enum Operation {
    GetStaticPageContent = 'getStaticPageContent',
}

export class SPSClient {
    api: APIClient;
    logger: Logger;
    endpoint?: string;
    constructor(api = new APIClient()) {
        this.api = api;
        this.logger = api.logger;
        if (api.endpoints != null && api.endpoints.serviceEndpoints != null) {
            this.endpoint = api.endpoints.serviceEndpoints[Services.PVStarlightPresentationServiceLambda] as string;
        }
    }

    call = async <Req, Res>(operation: Operation, body: Req, operationType: OperationType, context: RequestContext) => {
        if (global.__SERVER__) {
            const { URL } = require('url');
            let headers: Record<string, string> = {
                'x-amz-target': `com.amazon.pvstarlightpresentationservicelambda.${operation}`,
                'content-type': 'application/x-amz-json-1.1',
            };

            if (this.api.authentication && this.api.authentication.authMode !== AuthMode.OFF) {
                try {
                    if (!this.endpoint) {
                        throw new Error('Endpoint is invalid');
                    }

                    const url: URL = new URL(this.endpoint);
                    if (url.protocol !== 'https:') {
                        throw new Error(`Given end point protocol '${url.protocol}' is incompatible with AuthMode '${this.api.authentication.authMode}'. Only https is supported.`);
                    }

                    const hostname: string = url.hostname;
                    const accessToken: AccessToken = await this.api.authentication.cloudauthClient.getAccessToken({
                        host: hostname,
                        realm: 'PVStarlightPresentationServiceLambda',
                        scope: `https://aaa.amazon.com/scopes/PVStarlightPresentationServiceLambda#${operation}`,
                    });
                    headers.Authorization = `${accessToken.tokenType} ${accessToken.token}`;
                } catch (err) {
                    this.logger.error('Error occurred while generating access token', err);
                    // We shouldn't throw in SHADOW mode
                    if (this.api.authentication.authMode === AuthMode.ON) {
                        throw err;
                    }
                }
            }
            const operationUrl: URL = new URL(operation, this.endpoint);
            const req = constructRequest(this.logger, context.requestID, operationUrl.href, body, {
                name: `PVStarlightPresentationService ${operation}`,
                requester: 'SPSClient',
                operationType,
                headers,
            });

            return await this.api.call(...req) as Res;
        } else {
            const url = `/gp/video/starlightapi/${operation}`;
            const req = constructRequest(this.logger, context.requestID, url, body, {
                name: `PVStarlightPresentationService ${operation}`,
                requester: 'SPSClient',
                operationType,
            });

            return await this.api.call(...req) as Res;
        }
    }

    async GetStaticPageContent(body: GetStaticPageContentRequest, context: RequestContext) {
        return await this.call<GetStaticPageContentRequest, GetStaticPageContentResponse>(Operation.GetStaticPageContent, body, OperationType.READ, context);
    }
}
